export const ACTION_PREVIEW_PARTS = [
  'container',
  'header',
  'title',
  'badge',
  'content',
  'footer',
] as const;
